import { PlatformAuthProvider } from "@agentech/auth-client";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { config } from "./config";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <PlatformAuthProvider config={config}>
        <App />
      </PlatformAuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
